import { render, staticRenderFns } from "./subIssueClarificationNotice.vue?vue&type=template&id=5c010bbb&scoped=true"
import script from "./subIssueClarificationNotice.vue?vue&type=script&lang=js"
export * from "./subIssueClarificationNotice.vue?vue&type=script&lang=js"
import style0 from "./subIssueClarificationNotice.vue?vue&type=style&index=0&id=5c010bbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c010bbb",
  null
  
)

export default component.exports